"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadERC20__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_initialSupply",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "_decimals",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "AddedBlackList",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "Deprecate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_blackListedUser",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_balance",
                type: "uint256",
            },
        ],
        name: "DestroyedBlackFunds",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Issue",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "feeBasisPoints",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "maxFee",
                type: "uint256",
            },
        ],
        name: "Params",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Pause",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Redeem",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "RemovedBlackList",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Unpause",
        type: "event",
    },
    {
        inputs: [],
        name: "MAX_UINT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_evilUser",
                type: "address",
            },
        ],
        name: "addBlackList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "remaining",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "who",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balances",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "basisPointsRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_upgradedAddress",
                type: "address",
            },
        ],
        name: "deprecate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deprecated",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_blackListedUser",
                type: "address",
            },
        ],
        name: "destroyBlackFunds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_maker",
                type: "address",
            },
        ],
        name: "getBlackListStatus",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isBlackListed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "issue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "maximumFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "redeem",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_clearedUser",
                type: "address",
            },
        ],
        name: "removeBlackList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newBasisPoints",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newMaxFee",
                type: "uint256",
            },
        ],
        name: "setParams",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_from",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "upgradedAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class BadERC20__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_initialSupply, _name, _symbol, _decimals, overrides) {
        return super.deploy(_initialSupply, _name, _symbol, _decimals, overrides || {});
    }
    getDeployTransaction(_initialSupply, _name, _symbol, _decimals, overrides) {
        return super.getDeployTransaction(_initialSupply, _name, _symbol, _decimals, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BadERC20__factory = BadERC20__factory;
BadERC20__factory.bytecode = _bytecode;
BadERC20__factory.abi = _abi;
